import { Submission } from '../../types';

export const postSubmission = async (
  urlSlug: string,
  responses: Record<string, unknown>,
  captchaToken: string,
  metadataToken?: string,
): Promise<Submission> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/submissions/${urlSlug}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      responses,
      captchaToken,
      metadataToken,
    }),
  });
  const submission = await response.json();
  return submission.data;
};
